import { TYPO } from "./tokens.typography";

export const uiSansStack =
  (typeof window !== 'undefined' &&
   getComputedStyle(document.documentElement).getPropertyValue('--font-sans-stack').trim())
  || 'Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

export const uiMonoStack =
  (typeof window !== 'undefined' &&
   getComputedStyle(document.documentElement).getPropertyValue('--font-mono-stack').trim())
  || 'JetBrains Mono, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace';

// Align default size with TYPO.size.md to avoid conflicts
export const plotlyTypographyDefaults = { font: { family: uiSansStack, size: TYPO.size.md } } as const;

// Expose for presets/demos (optional window hook)
try { if (typeof window !== 'undefined') (window as any).__lumiUiSansStack = uiSansStack; } catch {}

export function withPlotTypography(layout: Partial<Plotly.Layout> = {}): Partial<Plotly.Layout> {
  const base = {
    font: { family: uiSansStack, size: TYPO.size.md, color: TYPO.color.primary },
    title: { font: { family: uiSansStack, size: TYPO.size.xl, color: TYPO.color.primary } },
    legend: { font: { family: uiSansStack, size: TYPO.size.sm } },
    xaxis: {
      title: { font: { size: TYPO.size.md, family: uiSansStack, color: TYPO.color.primary } },
      tickfont: { size: TYPO.size.sm, family: uiSansStack, color: TYPO.color.primary }
    },
    yaxis: {
      title: { font: { size: TYPO.size.md, family: uiSansStack, color: TYPO.color.primary } },
      tickfont: { size: TYPO.size.sm, family: uiSansStack, color: TYPO.color.primary }
    },
    hoverlabel: { font: { family: uiSansStack, size: TYPO.size.sm } },
    annotations: []
  } as Partial<Plotly.Layout>;
  return { ...base, ...layout };
}


